document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initMarquee();
  initCountUp();
  initGallery();
  initVariantPicker();
  initRandomCategories();
});

function initRandomCategories() {
  document.querySelectorAll('[data-vk-random-grid]').forEach(function (grid) {
    var pool = Array.from(grid.querySelectorAll('[data-vk-pool]'));
    var pinned = Array.from(grid.querySelectorAll('[data-vk-pinned]'));
    var count = parseInt(grid.dataset.vkRandomCount, 10) || 5;

    for (var i = pool.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp;
    }

    var selected = pool.slice(0, count);
    var discarded = pool.slice(count);
    discarded.forEach(function (el) { el.remove(); });
    selected.forEach(function (el) { grid.appendChild(el); });
    pinned.forEach(function (el) { grid.appendChild(el); });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.vk-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { els.forEach(function (el) { el.classList.add('vk-visible'); }); return; }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vk-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initMarquee() {
  document.querySelectorAll('[data-vk-marquee]').forEach(function (wrap) {
    var track = wrap.querySelector('.vk-marquee-track');
    if (!track) return;
    if (!track.dataset.duplicated) {
      track.innerHTML += track.innerHTML;
      track.dataset.duplicated = 'true';
    }
    var speed = parseFloat(wrap.dataset.vkMarquee) || 40;
    track.style.animationDuration = speed + 's';
  });
}

function initCountUp() {
  var stats = document.querySelectorAll('[data-vk-count]');
  if (!stats.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var run = function (el) {
    var target = parseFloat(el.dataset.vkCount) || 0;
    var suffix = el.dataset.vkSuffix || '';
    var decimals = (el.dataset.vkCount.split('.')[1] || '').length;
    if (reduce) { el.textContent = target.toFixed(decimals) + suffix; return; }
    var start = 0;
    var duration = 1400;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = start + (target - start) * eased;
      el.textContent = value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  };
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { run(entry.target); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.6 });
  stats.forEach(function (el) { observer.observe(el); });
}

function initGallery() {
  document.querySelectorAll('[data-vk-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-vk-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-vk-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.dataset.vkGalleryThumb;
        main.src = url;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });
}

function initVariantPicker() {
  document.querySelectorAll('[data-vk-product-form]').forEach(function (form) {
    var variantsEl = form.querySelector('[data-vk-variants-json]');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-vk-add-btn]');
    var priceNow = form.querySelector('[data-vk-price-now]');
    var priceWas = form.querySelector('[data-vk-price-was]');
    var optionGroups = form.querySelectorAll('[data-vk-option-index]');

    function currentSelection() {
      var selection = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.vk-swatch.active');
        selection.push(active ? active.dataset.value : null);
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateAvailability(currentVariant) {
      var selection = currentSelection();
      optionGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll('.vk-swatch').forEach(function (btn) {
          var testSelection = selection.slice();
          testSelection[groupIndex] = btn.dataset.value;
          var matchingVariant = variants.find(function (v) {
            return v.options.every(function (opt, i) {
              return testSelection[i] === null || opt === testSelection[i];
            });
          });
          btn.disabled = !matchingVariant;
          var priceEl = btn.querySelector('.vk-swatch-price');
          if (priceEl) {
            if (matchingVariant && currentVariant && matchingVariant.price !== currentVariant.price) {
              priceEl.textContent = formatMoney(matchingVariant.price);
            } else {
              priceEl.textContent = '';
            }
          }
        });
      });
    }

    function refresh() {
      var selection = currentSelection();
      var variant = findVariant(selection);
      updateAvailability(variant);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailableText || 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.dataset.addText : addBtn.dataset.soldOutText;
      }
      if (variant.featured_image) {
        var mainImg = document.querySelector('[data-vk-gallery-main]');
        if (mainImg) { mainImg.src = variant.featured_image; }
        document.querySelectorAll('[data-vk-gallery-thumb]').forEach(function (thumb) {
          thumb.classList.toggle('active', thumb.dataset.vkGalleryThumb === variant.featured_image);
        });
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.vk-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          group.querySelectorAll('.vk-swatch').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          refresh();
        });
      });
    });

    refresh();
  });
}
